export default __webpack_public_path__ + "static/media/travel.515adaad.png";